<template>
	<div id="body" v-if="show">
		<div class="overlay">
			<div class="container">
				<div class="row">
					<div class="col-md-6 col-sm-6">
						<div class="page-title wow bounceInLeft animated animated" ata-wow-delay="0.4s" style="visibility: visible; animation-name: bounceInLeft;">
							<h1>{{home}}</h1>
						</div>
					</div>
					<div class="col-md-6 col-sm-6">
						<ul class="page-breadcrumb wow bounceInRight animated animated" ata-wow-delay="0.4s" style="visibility: visible; animation-name: bounceInRight;">
							<li>
								<router-link to="/committee">{{home}}</router-link>
							</li>
							<li class="active">
								<a href="javascript:;">{{category[category_ind].title}}</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="page-seperate"></div>
		<div id="content">
			<section class="blog-section">
				<div class="container">
					<div class="class-box">
						<div class="class col-md-2 col-xs-4" :class="index == category_ind ? 'active' : ''" v-for="(item,index) in category" :key="index" @click="onTab(index)">
							{{item.title}}
						</div>
					</div>
					<div class="row" v-if="category_ind == 0">
						<!--Blog Section-->
						<div class="col-md-12 col-xs-12">
							<article id="post-2" class="post-content-area wow fadeInDown animated post-2 page type-page status-publish hentry" data-wow-delay="0.4s">
								<div class="blog-featured-img"></div>
								<div class="post-content">
									<div class="entry-content" v-html="article.content"></div>
								</div>
							</article>
						</div>
						<!--/Blog Section-->
					</div>
					<div class="row" id="blog" v-if="category_ind != 0">
						<!--Blog Section-->
						<div class="col-md-8 col-sm-7 col-xs-12">
							<article id="post-82" class="post-82 post type-post status-publish format-standard hentry category-uncategorized" data-wow-delay="0.4s" v-for="item in list">
								<div class="entry-meta">
									<span class="entry-date">
										<a href="javascript:;"><time datetime="">{{item.date}}</time></a>
									</span>
								</div>
								<header class="entry-header">
									<h3 class="entry-title"><router-link :to="{name:'comm_article',params: { id: item.article_id }}">{{item.title}}</router-link></h3>
									<div class="entry-meta">
										<span class="author">{{lang == 1 ? '作者' : 'Author'}} <a rel="tag" href="javascript:;">{{item.author_name}}</a></span>
										<span class="cat-links">{{lang == 1 ? '在' : 'in'}}<a href="javascript:;" rel="category tag">{{item.category}}</a></span>
									</div>
								</header>
								<div class="entry-content">
									<figure class="wp-block-image size-large is-resized" style="display: block;">
										<img loading="lazy" :src="baseUrl + item.cover_image" alt="" class="wp-image-83" style="width: 100%;" />
										<figcaption class="text-content" v-html="item.content" style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;"></figcaption>
									</figure>
								</div>
							</article>
						</div>
						<!--/Blog Section-->
						<!--Sidebar Section-->
						<div class="col-md-4 col-sm-5 col-xs-12">
							<div class="sidebar">
								<aside id="search-1" class="widget widget_search wow fadeInDown animated" data-wow-delay="0.4s">
									<div class="section-header wow fadeInDown animated" data-wow-delay="0.4s">
										<h3 class="widget-title">Search</h3></div>
										<form method="get" id="searchform" class="search-form" action="" ref="form">
											<label><input type="search" class="search-field" :placeholder="lang == 1 ? '搜索' : 'Search'" v-model="search" /></label>
											<label><input type="button" class="search-submit" :value="lang == 1 ? '搜索' : 'Search'" @click="onSubmit"></label>
										</form>
								</aside>
								<aside id="recent-posts-1" class="widget widget_recent_entries wow fadeInDown animated" data-wow-delay="0.4s">
									<div class="section-header wow fadeInDown animated" data-wow-delay="0.4s">
										<h3 class="widget-title">{{lang == 1 ? '近期文章' : 'Latest Release' }}</h3></div>
									<ul>
										<li v-for="item in right">
											<router-link :to="{name:'article',params: { id: item.article_id }}">{{item.title}}</router-link>
										</li>
									</ul>

								</aside>
							</div>
						</div>
						<!--Sidebar Section-->
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	import { getArticleCategory, getArticle } from '../api/api';
	export default {
		data() {
			return {
				show: false,
				baseUrl: 'http://admin.brlsea.org',
				category: [[]],
				category_ind: 0,
				article: '',
				search: '',
				right: [],
				list: [],
				home: ''
			};
		},
		props: ['lang'],
		methods: {
			onTab(ind){
				if(ind == this.category_ind){
					return false;
				}
				this.category_ind = ind;
				let id = this.category[ind].id;
				if(ind == 0){
					this.onGetData(id);
				}else{
					this.list = [];
					this.onGetArticle(id);
				}
			},
			onGetClass() {
				let that = this;
				getArticleCategory({
					lang: this.lang,
				}).then(res => {
					if(res.code == 1) {
						that.category = res.data;
						that.onGetData(res.data[0].id);
					}
				});
			},
			onGetData(category) {
				let that = this;
				getArticle({
					lang: this.lang,
					type: 2,
					category: category,
				}).then(res => {
					if(res.code == 1) {
						that.article = res.data[0];
						that.show = true;
					}
				});
			},
			onGetArticle(category){
				let that = this;
				getArticle({
					lang: this.lang,
					page: 1,
					size: 1000,
					type: 2,
					category: category,
				}).then(res=>{
					if(res.code == 1) {
						that.list = res.data;
					}
				})
			},
			onGetArticleRight(){
				let that = this;
				getArticle({
					lang: this.lang,
					page: 1,
					size: 3
				}).then(res=>{
					if(res.code == 1) {
						that.right = res.data;
					}
				})
			},
			onSubmit(){
				this.$router.push({
					name: 'search',
					params: {
						search: this.search
					}
				})
			},
		},
		created() {
			this.onGetClass();
			this.onGetArticleRight();
		},
		mounted() {
			this.home = $(".menu-item.active a").text();
		}
	};
</script>

<style scoped="scoped">
	.class-box {
		height: 45px;
		margin-bottom: 2px;
	}
	.class {
		height: 45px;
		line-height: 45px;
		background: #21202e;
		color: #fff;
		box-sizing: border-box;
		position: relative;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		font-size: 14px;
		padding: 0 0 0 15px;
		/*border-right: 1px solid #FFFFFF;*/
	}
	
	.class.active {
		background: #ce1b28;
	}
	
	.class::before {
		content: "";
		width: 6px;
		height: 45px;
		background: #ce1b28;
		position: absolute;
		top: 0;
		left: 0;
	}
	
	.class.active::before{
		content: "";
		width: 6px;
		height: 45px;
		background: #fff;
		/*border-left: 1px solid #FFFFFF;*/
		position: absolute;
		top: 0;
		left: 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/committee.vue